import { spCandidateSchedulingAccommodationDetailsLocs } from './accommodation/accommodation-details/accommodation-details.locs';
import { spCandidateSchedulingAccommodationLocs } from './accommodation/accommodation.locs';
import { spCandidateSchedulingAccommodationFormLocs } from './accommodation/accommodations-edit-form/accommodations-edit-form.locs';
import { spCandidateSchedulingAccommodationCreateLocs } from './accommodation/create-accommodation/create-accommodation.locs';
import { spCandidateSchedulingAppointmentsLocs } from './appointments/appointments.locs';
import { spEligibilitiesSectionLocs } from './eligibilities-section/eligibilities-section.locs';
import { spEligibilitiesLocs } from './eligibilities/eligibilities.locs';
import { spEligibilityEditDialogLocs } from './eligibility-edit-dialog/eligibility-edit-dialog.locs';
import { spEligibilityGrantDialogLocs } from './eligibility-grant-dialog/eligibility-grant-dialog.locs';
import { spEligibilityRevokeDialogLocs } from './eligibility-revoke-dialog/eligibility-revoke-dialog.locs';
import { spCandidateSchedulingEligibleExamsLocs } from './facebook-eligible-exams/facebook-eligible-exams.locs';
import { spCandidateSchedulingEligibleExamsMenuLocs } from './facebook-eligible-exams/schedule-exam-menu/schedule-exam-menu.locs';
import { spNcarbAuthLocs } from './ncarb/models/ncarb-auth-locs';
import { spCandidateHistorySchedulingLocs } from './scheduling/scheduling.locs';

export const candidateSchedulingModuleLocs = {
	...spEligibilitiesSectionLocs,
	...spCandidateHistorySchedulingLocs,
	...spCandidateSchedulingAccommodationDetailsLocs,
	...spCandidateSchedulingAccommodationFormLocs,
	...spCandidateSchedulingAccommodationCreateLocs,
	...spCandidateSchedulingAccommodationLocs,
	...spCandidateSchedulingEligibleExamsLocs,
	...spCandidateSchedulingEligibleExamsMenuLocs,
	...spCandidateSchedulingAppointmentsLocs,
	...spEligibilitiesLocs,
	...spNcarbAuthLocs,
	...spEligibilityGrantDialogLocs,
	...spEligibilityRevokeDialogLocs,
	...spEligibilityEditDialogLocs,
};
